export enum Action {
  PLUS,
  MINUS
}
